/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as yup from 'yup';

import {
  NO_ONLY_SPACES_REGEX,
  PHONE_REGEX
} from '../../util/validation/constants';
import { messages as TwilioAuth } from '../twilio-auth/messages';
import { AdvancedOptions } from './advanced-tab/messages';
import { ClickToChat } from './click-to-chat-tab/messages';

export const settingsSchema = yup.object().shape({
  private: yup
    .object()
    .shape({
      secrets: yup
        .object()
        .shape({
          twilio_authentication_token: yup
            .string()
            .required(TwilioAuth.authTokenRequired)
            .matches(/^[0-9a-f]{32}$/, {
              message: TwilioAuth.authTokenError,
              excludeEmptyString: true
            })
        })
        .nullable()
        .default(undefined),
      phone_number: yup
        .string()
        .matches(PHONE_REGEX, {
          message: ClickToChat.phoneNumberError,
          excludeEmptyString: true
        })
        .matches(NO_ONLY_SPACES_REGEX, {
          message: ClickToChat.phoneNumberEmptyError,
          excludeEmptyString: true
        })
        .nullable()
        .default(undefined)
    })
    .nullable()
    .default(undefined),
  messages: yup.object().shape({
    errors: yup.object().shape({
      runtime: yup
        .string()
        .required(AdvancedOptions.runtimeErrorMessageRequired)
        .default(AdvancedOptions.runtimeErrorMessageDefault.defaultMessage),
      transfer: yup
        .string()
        .required(AdvancedOptions.transferErrorMessageRequired)
        .default(AdvancedOptions.transferErrorMessageDefault.defaultMessage)
    }),
    options_configured: yup
      .string()
      .required(AdvancedOptions.configuredMessageRequired)
      .default(AdvancedOptions.configuredMessageDefault.defaultMessage),
    invite_user_to_open: yup.string().default('')
  }),
  account_sid: yup
    .string()
    .required(TwilioAuth.accountSidRequired)
    .matches(/^[0-9A-Ca-f]{34}$/, {
      message: TwilioAuth.accountSidError,
      excludeEmptyString: true
    }),
  webhook_url: yup.string().required()
});

export const FIELDS = {
  ACCOUNT_SID: 'account_sid',
  INVITE_USER_TO_OPEN_MESSAGE: 'messages.invite_user_to_open',
  OPTIONS_CONFIGURED_MESSAGE: 'messages.options_configured',
  PHONE_NUMBER: 'private.phone_number',
  RUNTIME_ERROR_MESSAGE: 'messages.errors.runtime',
  TRANSFER_ERROR_MESSAGE: 'messages.errors.transfer',
  TWILIO_AUTHENTICATION_TOKEN: 'private.secrets.twilio_authentication_token',
  WEBHOOK_URL: 'webhook_url'
};

export const SUBSCRIBE_PAYLOAD_TRANSFORM = {
  [FIELDS.ACCOUNT_SID]: 'account_sid',
  [FIELDS.TWILIO_AUTHENTICATION_TOKEN]: 'auth_token',
  [FIELDS.OPTIONS_CONFIGURED_MESSAGE]: 'options_configured_message',
  [FIELDS.RUNTIME_ERROR_MESSAGE]: 'runtime_error_message',
  [FIELDS.TRANSFER_ERROR_MESSAGE]: 'transfer_error_message',
  [FIELDS.INVITE_USER_TO_OPEN_MESSAGE]: 'user_message',
  [FIELDS.WEBHOOK_URL]: 'webhook_url'
};
